export default [
    {
        path: '/partner-categories',
        name: 'partner-categories',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/PartnerCategories.vue')
    }
]